/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
// tab page
import PartnerSiteInfo from "../Partner/PartnersiteInfo";
import PartnerInfo from "../Partner/PartnerInfo";

import { ModalHeader, ModalTab } from "../Modal";

const Pertner = ({ partnerCompany }) => {
  const [activeTab, setActiveTab] = useState('partnerInfo');

  const _setActiveTab = (value) => {
    setActiveTab(value)
  }

  const tabList = [
    {
      label: "파트너스 정보",
      action: _setActiveTab,
      value: "partnerInfo",
    },
    {
      label: "홈페이지 정보",
      action: _setActiveTab,
      value: "partnerSiteInfo",
    },
  ];



  return partnerCompany ?(
      <div className="page-content">
      <ModalHeader>{partnerCompany.name} 내 정보</ModalHeader>
        <ModalTab tabList={tabList} active={activeTab} />
        {activeTab === 'partnerInfo' &&
        <PartnerInfo
          partnerCompanyIdx={partnerCompany.idx}
          mode={"create"}
        />}
        {activeTab === 'partnerSiteInfo' &&
          <PartnerSiteInfo
          partnerCompanyIdx={partnerCompany.idx}
            mode={"create"}
        />}
    </div>
  ) : <></>;
};

export default Pertner;
